import { useCallback } from "react";
import { IconType } from "react-icons";
import * as FontAwesomeIcons from "react-icons/fa";
import * as FeatherIcons from "react-icons/fi";
import * as MaterialDesignIcons from "react-icons/md";
import * as BiIcons from "react-icons/bi";
import * as BsIcons from "react-icons/bs";
import * as PiIcons from "react-icons/pi";
import * as SiIcons from "react-icons/si";
import CustomAiPerson from "@assets/images/svg/icons/ai-person.svg";
import CustomBulbOn from "@assets/images/svg/icons/bulb-on.svg";
import CustomCalenderSetting from "@assets/images/svg/icons/calender-setting.svg";
import CustomIncreaseStats from "@assets/images/svg/icons/increase-stats.svg";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import linkedIn from "@assets/images/svg/icons/linkedIn.svg";

type CIconType = Record<string, IconType>;

const CustomIcons: Record<string, IconType> = {
  CustomAiPerson,
  CustomBulbOn,
  CustomCalenderSetting,
  CustomIncreaseStats,
  IoMdCheckmarkCircleOutline,
  linkedIn,
};

const useIcons = () => {
  const getFromReactIcons = useCallback(
    (iconName: string | undefined): IconType | null => {
      let icon = null;
      if (iconName) {
        const isFaIcon = iconName?.startsWith("Fa");
        const isFeatherIcon = iconName?.startsWith("Fi");
        const isMaterialDesignIcon = iconName?.startsWith("Md");
        const isBiIcon = iconName?.startsWith("Bi");
        const isBsIcon = iconName?.startsWith("Bs");
        const isPiIcon = iconName?.startsWith("Pi");
        const isSiIcon = iconName?.startsWith("Si");
        if (isFaIcon) {
          icon = (FontAwesomeIcons as CIconType)[iconName];
        } else if (isFeatherIcon) {
          icon = (FeatherIcons as CIconType)[iconName];
        } else if (isMaterialDesignIcon) {
          icon = (MaterialDesignIcons as CIconType)[iconName];
        } else if (isBiIcon) {
          icon = (BiIcons as CIconType)[iconName];
        } else if (isBsIcon) {
          icon = (BsIcons as CIconType)[iconName];
        } else if (isPiIcon) {
          icon = (PiIcons as CIconType)[iconName];
        } else if (isSiIcon) {
          icon = (SiIcons as CIconType)[iconName];
        } else {
          icon = CustomIcons?.[iconName];
        }
      }
      return icon;
    },
    []
  );
  return { getFromReactIcons };
};

export default useIcons;
